import React from 'react';
import JoditEditor from 'jodit-react';
import { observer } from 'mobx-react-lite';
import { EditorConfig } from './editor-vm';

function EditorView({
   value,
   onValueChange,
   name,
}: {
   name?: string;
   value: string;
   onValueChange: (value: string) => void;
}) {
   return (
      <JoditEditor
         name={name}
         value={value}
         config={EditorConfig.config()}
         onBlur={(value) => {
            onValueChange(value);
         }}
      />
   );
}

export const Editor = React.memo(EditorView, (prev, next) => prev.value === next.value);
